/**
 * Маpперы для преобразования данных из формата Supabase (snake_case) в доменные типы
 */

import type {
  Wishlist,
  PrivacyType,
  BookingVisibilityType,
  WishlistCollaborator,
  CollaboratorRole,
  CollaboratorStatus,
  DbWishlist,
  DbWishlistItem,
  DbWishlistCollaboratorWithUser,
} from '../model';
import { mapDbItemToDomain } from '@/features/wishlist-item';

/**
 * Маппинг строки wishlists из БД в доменный тип Wishlist
 *
 * @param dbWishlist — строка из таблицы wishlists
 * @param allItems — все items для фильтрации по wishlist_id
 */
export function mapDbWishlistToDomain(dbWishlist: DbWishlist, allItems: DbWishlistItem[]): Wishlist {
  const wishlistItems = allItems.filter(i => i.wishlist_id === dbWishlist.id);

  return {
    id: dbWishlist.id,
    userId: dbWishlist.user_id,
    title: dbWishlist.title,
    description: dbWishlist.description || undefined,
    icon: dbWishlist.icon || undefined,
    iconId: dbWishlist.icon_id || dbWishlist.icon || undefined,
    privacy: dbWishlist.privacy as PrivacyType,
    eventDate: dbWishlist.event_date ? new Date(dbWishlist.event_date) : undefined,
    bookingVisibility: dbWishlist.booking_visibility as BookingVisibilityType,
    favoriteCount: dbWishlist.favorite_count || 0,
    itemCount: wishlistItems.length,
    items: wishlistItems.map(item => mapDbItemToDomain(item, dbWishlist.id)),
    createdAt: new Date(dbWishlist.created_at),
    updatedAt: new Date(dbWishlist.updated_at),
  };
}

/**
 * Маппинг данных соавтора из БД в доменный тип WishlistCollaborator
 *
 * @param dbCollaborator — строка из wishlist_collaborators с joined profiles
 */
export function mapDbCollaboratorToDomain(
  dbCollaborator: DbWishlistCollaboratorWithUser,
): WishlistCollaborator {
  return {
    id: dbCollaborator.id,
    wishlistId: dbCollaborator.wishlist_id,
    userId: dbCollaborator.user_id,
    role: dbCollaborator.role as CollaboratorRole,
    invitedBy: dbCollaborator.invited_by,
    status: dbCollaborator.status as CollaboratorStatus,
    invitedAt: new Date(dbCollaborator.invited_at),
    acceptedAt: dbCollaborator.accepted_at ? new Date(dbCollaborator.accepted_at) : undefined,
    createdAt: new Date(dbCollaborator.created_at),
    updatedAt: new Date(dbCollaborator.updated_at),
    user: dbCollaborator.user ? {
      id: dbCollaborator.user.id,
      username: dbCollaborator.user.username,
      fullName: dbCollaborator.user.display_name || undefined,
      lastName: dbCollaborator.user.last_name || undefined,
      avatarUrl: dbCollaborator.user.avatar_url || undefined,
    } : undefined,
    inviter: dbCollaborator.inviter ? {
      id: dbCollaborator.inviter.id,
      username: dbCollaborator.inviter.username,
      fullName: dbCollaborator.inviter.display_name || undefined,
      lastName: dbCollaborator.inviter.last_name || undefined,
      avatarUrl: dbCollaborator.inviter.avatar_url || undefined,
    } : undefined,
  };
}